<template>
  <div class="logistics">
    <Title text="物流信息" />
    <!-- 物流公司及单号 -->
    <div class="company">
      <p>物流公司：顺丰快递</p>
      <p>快递单号：123456789</p>
    </div>
    <!-- 物流信息 -->
    <div class="logistics-content">
      <van-steps direction="vertical" :active="0" active-color="#ff9900">
        <van-step>
          <h3>【城市】物流状态1</h3>
          <p>2016-07-12 12:40</p>
        </van-step>
        <van-step>
          <h3>【城市】物流状态2</h3>
          <p>2016-07-11 10:00</p>
        </van-step>
        <van-step>
          <h3>快件已发货</h3>
          <p>2016-07-10 09:30</p>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
import Title from "../components/Title";
export default {
  name: "Logistics",
  data() {
    return {};
  },
  components: {
    Title
  }
};
</script>

<style lang="less" scoped>
.logistics {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.company {
  background: #fff;
  padding: 30px;
  margin: 20px 0;
  p {
    font-size: 28px;
  }
  p:last-child {
    margin-top: 30px;
  }
}
</style>